import { render, staticRenderFns } from "./MicrosoftTeamsForm.vue?vue&type=template&id=0785bf6c"
import script from "./MicrosoftTeamsForm.vue?vue&type=script&lang=js"
export * from "./MicrosoftTeamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports